<template>
  <div>
    <MobileNavigation></MobileNavigation>
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 bg-slate-900 p-2" style="height:100%">
        <br><br>

        <div class="mt-2">
          <div class="shadow rounded-lg p-2">
            <div class="grid grid-cols-2 gap-5">
              <div class="text-left">
                <span class="text-xl font-weight-bold">Some Text</span> <br>
              </div>
              <div class="text-right">
                <span class="text-sm">Some Text</span>  
              </div>  
            </div>
            <span class="text-sm">Some Text</span>  
                <br>
            <span class="text-sm">Some Text</span>

          </div>
        </div>

  </div>
      
  </div>
</template>
<style scoped>
    .noselect {
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
    }


    .no-decoration{
      text-decoration: none;
    }

    .no-decoration:hover{
      text-decoration: none;
    }

    </style>

<script>
import MobileNavigation from "@/Layouts/MobileNavigation.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from '@/Jetstream/NavLink.vue'


export default {
  props: ["sessions"],

  components: {
    MobileNavigation,
    Welcome,
    PageTitle,
    JetNavLink,

  },
  data() {
    return {
      title: "Attendance Menu",
      username: null,
      password: null,

    };
  },
  methods: {

    addMoreImage() {
      var camera='<span class=\"bg-black pl-2 pr-2 pt-4 pb-2\"><i class=\"fas fa-camera text-white text-4xl\"></i></span>';
      var element=document.getElementById("cameraContainer");
      element.appendChild(camera);
    },

    openPunchMap(){
            app.startPunchMap();
        }
  },
  mounted() {
    
  },
};
</script>
